<template>
    <top-users :users="monthlyLeaderboardUsers" :style="{ height: monthlyLeaderboardUsers.length === 1 ? '150px' : '' }" />
    <users-list :users="monthlyLeaderboardUsers" />
</template>



<script setup>

import { computed } from 'vue';
import { LeaderboardStore } from "@/store/LeaderboardStore";
import TopUsers from "@/components/Leaderboard/Top-Users.vue";
import UsersList from "@/components/Leaderboard/Users-List.vue";

const leaderboardStore = LeaderboardStore();

const monthlyLeaderboardUsers = computed(() => {
    return leaderboardStore.last30DaysLeaderboard;
});

</script>